import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./style/theme";
import { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import InfoFetch from "./components/accountAggregator/InfoFetch";
import WebViewComponent from "./components/accountAggregator/WebViewComponent";
import ChildQuestion from "./components/childPlanning/ChildQuestion";
import CurrentPortfolio from "./components/currentPortfolio/CurrentPortfolio";
import AgentDashboard from "./components/dashboard/agentDashboard/AgentDashboard";
import Dashboard from "./components/dashboard/Dashboard";
import FinancialSnapshot from "./components/dashboard/FinancialSnapshot";
import InvestmentGoal from "./components/futurePlanning/investment/InvestmentGoal";
import RetirementGoal from "./components/futurePlanning/retirement/RetirementGoal";
import Goal from "./components/goal/Goal";
import FinanacialQuestion from "./components/monthlyIncome/FinanacialQuestion";
import Onbording from "./components/onbording/Onboarding";
import { String } from "./constants/Strings";
import AccountAagregatorProvider from "./Hooks/context/AccountAaggregator";
import AgentDataProvider from "./Hooks/context/AgentData";
import AuthProvider from "./Hooks/context/AuthContext";
import DataProvider from "./Hooks/context/ChildData";
import EditFlagProvider from "./Hooks/context/EditFlagContext";
import FinancialDetailsProvider from "./Hooks/context/FinancialDetails";
import OTPVerifyProvider from "./Hooks/context/OTPVeriryContext";
import { ReloadProvider } from "./Hooks/context/RealodContext";
import usePageTracking from "./Hooks/CustomHooks/usePageTracking";
import useDisableNativeBackButton from "./Hooks/CustomHooks/useDisableNativeBackButton";
import { API_KEY, API_BASE_URL } from "./config/env";

export const Urls = () => {
  return {
    baseURL: API_BASE_URL,
    APIKey: API_KEY,
  };
};

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ReloadProvider>
      <AuthProvider>
        <DataProvider>
          <FinancialDetailsProvider>
            <AccountAagregatorProvider>
              <AgentDataProvider>
                <OTPVerifyProvider>
                  <EditFlagProvider>
                    <ThemeProvider theme={theme}>
                      <CssBaseline />
                      <Router>
                        <PageTrackerWrapper />
                        <Routes>
                          <Route
                            path={String.navigations.initiate}
                            element={<Onbording />}
                          ></Route>
                          <Route
                            path={String.navigations.currentportfolio}
                            element={<CurrentPortfolio />}
                          ></Route>
                          <Route
                            path={String.navigations.financialquestion}
                            element={<FinanacialQuestion />}
                          />
                          <Route
                            path={String.navigations.goal}
                            element={<Goal />}
                          />
                          <Route
                            path={String.navigations.childquestion}
                            element={<ChildQuestion />}
                          />

                          <Route
                            path={String.navigations.retirementgoal}
                            element={<RetirementGoal />}
                          ></Route>
                          <Route
                            path={String.navigations.investmentgoal}
                            element={<InvestmentGoal />}
                          />
                          <Route
                            path={String.navigations.fetchinfo}
                            element={<InfoFetch />}
                          />
                          <Route
                            path={String.navigations.webview}
                            element={<WebViewComponent />}
                          />
                          <Route
                            path={String.navigations.financialsnapshot}
                            element={<FinancialSnapshot />}
                          />
                          <Route
                            path={String.navigations.customerdashboard}
                            element={<Dashboard />}
                          />
                          <Route
                            path={String.navigations.dashboard}
                            element={<AgentDashboard />}
                          />
                        </Routes>
                      </Router>
                    </ThemeProvider>
                  </EditFlagProvider>
                </OTPVerifyProvider>
              </AgentDataProvider>
            </AccountAagregatorProvider>
          </FinancialDetailsProvider>
        </DataProvider>
      </AuthProvider>
    </ReloadProvider>
  );
}

export default App;

const PageTrackerWrapper = () => {
  usePageTracking();
  useDisableNativeBackButton();
  return null;
};
